/*
 * --------------------------------------------------------------------------- *
 * File: cloud.js                                                              *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Sat Oct 29 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */



import axios from "axios";
import Constants from "./constants";

export class Cloud {
  static headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "",
    },
  };

  static post = async (url, body) => {
    var response = await axios.post(url, { ...body, bank: Constants.bank }, Cloud.headers);
    return response.data;
  };

  static get = async (url) => {
    var response = await axios.get(url, Cloud.headers);
    return response.data;
  };

  static setToken = (token) => {
    Cloud.headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
  };

  static log = (msg) => {
    console.log(msg);
  };
}
